export const PATH_ALERTS: string = '/api/v2/alerts';
export const PATH_ALERTS_LOG: string = '/api/v2/alertLog';
export const PATH_ALERT_NOTIFICATION: string = '/api/v2/alertNotification';
export const PATH_ALERT_CONFIG: string = '/api/v2/alertConfig';
export const PATH_ALERT_CONFIG_CHANGE_STATUS: string =
  '/api/v2/alertConfigChangeStatus';
